import * as React from "react";
//import styles from './AdminLoginDialog.css';
import { v4 } from "uuid";

import { withStyles, WithStyles, createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import CircularProgress from '@material-ui/core/CircularProgress';

import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
//import '../../resources/img/bg1.jpg';
import { ThemeProvider } from '@material-ui/core/styles';

import { createMuiTheme } from '@material-ui/core/styles';
import red from '@material-ui/core/colors/red';
import TextField from '@material-ui/core/TextField';

import ExamServer from '../server/ExamServer'




import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpansionPanelActions from '@material-ui/core/ExpansionPanelActions';
import Chip from '@material-ui/core/Chip';
import Divider from '@material-ui/core/Divider';
import Fab from '@material-ui/core/Fab';
import CheckIcon from '@material-ui/icons/Check';



const theme = createMuiTheme({
    // palette: {
    //     primary: {
    //         main: '#44423e'
    //     },
    //     secondary: {
    //         main: '#FDC400',
    //         contrastText: '#fff'
    //     }
    // }

});


const styles = ((theme: Theme) => createStyles({
    root: {
        padding: theme.spacing(2)
    }
}))



export interface AdminLoginDialogProps extends WithStyles<typeof styles> {
    onLogin:() => void
}

export interface AdminLoginDialogState {
    usernameText: string,
    passwordText: string,
    loading: boolean,
    invalid: boolean
}


class AdminLoginDialog extends React.Component<AdminLoginDialogProps, AdminLoginDialogState> {

    
    server: ExamServer;


    constructor(props: AdminLoginDialogProps) {
        super(props);
        this.state = {
            usernameText: "",
            passwordText: "",
            loading: false,
            invalid:false
        };

        this.server = new ExamServer()


    }

    usernameTextChanged = (event: React.ChangeEvent<HTMLInputElement>) => {

        this.setState({ 
            usernameText: event.target.value,
            invalid:false
         });
    }
    usernameTextKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === "Enter") {
            this.login()
        }
    }

    passwordTextChanged = (event: React.ChangeEvent<HTMLInputElement>) => {

        this.setState({ 
            passwordText: event.target.value,
            invalid:false
         });
    }
    passwordTextKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === "Enter") {
            this.login()
        }
    }


    login = () => {
        
        this.setState({ loading: true });

        this.server.login(this.state.usernameText, this.state.passwordText).then(successful => {

            if(successful){

                this.props.onLogin && this.props.onLogin()
                this.setState({
                    loading: false,
                    invalid: false
                })

            }
            else {
                this.setState({
                    invalid: true,
                    loading: false
                })
            }


        })


    }


    render() {

        const { classes } = this.props;

        return (
            <React.Fragment>

                <Typography variant="h5" color="textPrimary" component="h5" align="center" gutterBottom>
                    Login
                </Typography>
{/* 
                <Typography variant="subtitle1" color="textSecondary" component="p" gutterBottom>
                    Please enter your administ
                </Typography> */}


                <TextField
                    label={"Username"}
                    error={this.state.invalid}
                    fullWidth
                    margin="normal"
                    value={this.state.usernameText}
                    onChange={this.usernameTextChanged}
                    onKeyPress={this.usernameTextKeyPress}
                    variant="outlined"

                />

                <TextField
                    label={"Password"}
                    error={this.state.invalid}
                    fullWidth
                    margin="normal"
                    value={this.state.passwordText}
                    onChange={this.passwordTextChanged}
                    onKeyPress={this.passwordTextKeyPress}
                    variant="outlined"
                    type="password"
                />


                <Button
                    variant="contained"
                    color="secondary"
                    fullWidth
                    onClick={this.login}
                    disabled={this.state.loading || this.state.usernameText.length === 0  || this.state.passwordText.length === 0 || this.state.invalid}
                    style={{marginTop:theme.spacing(3)}}
                >Login</Button>

            </React.Fragment>


        )
    }
}

export default withStyles(styles)(AdminLoginDialog);
